<style lang="less" scoped>

</style>

<template lang="pug">
  img.number(
    :style='{ width: width + "px" }'
    :src='`/static/numbers/${type}/${number}.png`')
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    number: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 12,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/number_panel.vue